module.exports = __webpack_public_path__ + "img/inactive.c219f9c7.svg";